<div mat-dialog-content class="mat-dialog-content">
  <img src="{{image}}" alt="Medical Report" class="popup_img">
</div>
<!-- <div mat-dialog-actions class="mat-dialog-actions" (click)="onClose()" align="end">
  <button mat-button mat-dialog-close mat-raised-button
    style="font-size: 27px; background: rgb(0 0 0 / 0%); color: #000; cursor: pointer;">×</button>
</div> -->